import React, { useMemo } from "react"
import {
  CardMedia,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Step,
  StepLabel,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded"
import { Link } from "react-router-dom"
import { getIcon } from "utils/icon"

export const DirectionStepItem = (props) => {
  const {
    navigateTo = null,
    primaryLabel = "",
    secondaryLabel = "",
    stepLabelProps = {},
    sx = {},
    venueLogo = "",
    ...restProps
  } = props

  const theme = useTheme()
  const { styleOverrides } = theme.components?.[`DirectionStepItem`] || {}
  const { root, listItem, listItemIcon, logoImage } = styleOverrides
  const isRtl = theme.isRtl

  const nextIcon = useMemo(
    () =>
      getIcon(theme?.assets?.nextIcon) || (
        <ArrowForwardIosRoundedIcon fontSize="medium" />
      ),
    [theme]
  )

  const navigateProps = navigateTo
    ? {
        component: Link,
        to: navigateTo,
        secondaryAction: (
          <IconButton
            aria-label="go to step"
            color="inherit"
            size="small"
            className={isRtl ? "is-rtl" : ""}
          >
            {nextIcon}
          </IconButton>
        ),
      }
    : {}

  return (
    <Step sx={deepmerge(root, sx)} active={true} {...restProps}>
      <StepLabel {...stepLabelProps}>
        <ListItem
          color="inherit"
          disablePadding
          sx={listItem}
          {...navigateProps}
        >
          {venueLogo && (
            <ListItemIcon sx={listItemIcon}>
              <CardMedia component="img" image={venueLogo} sx={logoImage} />
            </ListItemIcon>
          )}
          <ListItemText primary={primaryLabel} secondary={secondaryLabel} />
        </ListItem>
      </StepLabel>
    </Step>
  )
}
